import React from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
// images
import cradit from "../../assets/images/icons/cradit.svg";
import "./footer.scss";
import bglogo from "../../assets/images/bglogo.svg";
import hipaa from "../../assets/images/hipaa.png";
import SubscriptionModal from "../subscriptionModal";
import useSubscribeForm from "../../hooks/useSubscribeHook";
import CustomButton from "../Buttons/CustomButton";

const FooterBottom = () => {
  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };
  const { userDetails, showModel, handleChange, handleSubscribe, resetForm, setShowModel } = useSubscribeForm();
  return (
    <footer className="text-white position-relative">
      <img aria-hidden="true" className="bg-logo position-absolute top-50 start-100 translate-middle" src={bglogo} alt="bgLogo" />
      <div className="pt-5 pb-4">
        <Container>
          <Row className="text-center text-sm-start justify-content-sm-between">
            <Col xs={12} lg={4} className="mb-4">
              <Row className="justify-content-center text-center text-lg-start">
                <Col md={8} lg={12}>
                  <h5>THRIVE IN PRIVATE PRACTICE</h5>
                  <p>Sign up for free resources, community updates, and exclusive content and discounts</p>
                  <Form.Control
                    size="lg"
                    placeholder="Name"
                    aria-label="Name"
                    aria-describedby="basic-addon2"
                    name="fname"
                    onChange={(e) => handleChange(e)}
                    value={userDetails.fname}
                    maxLength={50}
                  />
                  <Form.Control
                    size="lg"
                    name="email"
                    className="my-3"
                    placeholder="Email Address"
                    aria-label="Email"
                    aria-describedby="basic-addon2"
                    onChange={(e) => handleChange(e)}
                    value={userDetails.email}
                  />
                  <CustomButton className="w-100 text-uppercase" variant="marketing" type="submit" gradient onClick={handleSubscribe}>
                    SIGN ME UP
                  </CustomButton>
                  <p className="my-1">
                    By entering your information, you’ll get exclusive insights delivered right to your inbox. It’s free. No Spam. Unsubscribe at any time. You
                    also agree to our{" "}
                    <u>
                      <Link to="/terms-of-service">Terms of Use</Link>
                    </u>{" "}
                    and{" "}
                    <u>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </u>
                    .
                  </p>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="d-lg-none"></Col>
            <Col xs={12} sm="auto" className="mb-4">
              <p className="fw-bold text-uppercase mb-2 f-title">General</p>
              <ul>
                <li>
                  <Link onClick={handleClickTop} to="/request-a-feature">
                    Request a Feature
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClickTop} to="/report-a-problem">
                    Report a Problem
                  </Link>
                </li>
                <li>
                  <Link onClick={handleClickTop} to="/upcoming-features">
                    Vote On Features
                  </Link>
                </li>
              </ul>
            </Col>
            <Col xs={12} sm="auto" className="mb-4">
              <p className="fw-bold text-uppercase mb-2 f-title">Partners</p>
              <ul>
                <li>
                  <a href="https://form.jotform.com/213503145744147" target="_blank" rel="noreferrer">
                    Become an Affiliate
                  </a>
                </li>
                <li>
                  <a href="https://form.jotform.com/213073879005355" target="_blank" rel="noreferrer">
                    Become a Vendor
                  </a>
                </li>
                <li>
                  <a href="https://form.jotform.com/222783896422062" target="_blank" rel="noreferrer">
                    Become a Guest Contributor
                  </a>
                </li>
              </ul>
            </Col>

            <Col xs={12} sm="auto" className="mb-4">
              <p className="fw-bold text-uppercase mb-2 f-title">Contact</p>
              <ul>
                <li>
                  <Link onClick={handleClickTop} to="/contact-us">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <a href="mailto:hello@claritycooperative.com">
                    <u>hello@claritycooperative.com</u>
                  </a>
                </li>
              </ul>
              <p className="fw-bold text-uppercase mb-2 f-title mt-4">Social</p>
              <ul className="d-flex justify-content-center justify-content-sm-start">
                <li className="mr-3">
                  <a href="https://www.facebook.com/claritycooperative/" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li className="mr-3">
                  <a href="https://www.instagram.com/claritycooperative/" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li className="mr-3">
                  <a href="https://www.linkedin.com/company/clarity-cooperative" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </li>
                <li className="mr-3">
                  <a href="https://www.youtube.com/channel/UCsVSeT3Y5H5438d5lIhw72w" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li className="">
                  <a href="https://www.pinterest.com/claritycooperative" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-pinterest"></i>
                  </a>
                </li>
              </ul>
              <a href="/security" target="_blank">
                <img className="mt-4" src={hipaa} alt="Hippa Compliant" />
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="copyright">
        <Container className="py-3">
          <Row className="justify-content-between">
            <Col xs={12} md="auto" className="text-center text-md-start">
              © Copyright 2024. The Clarity Cooperative and Clarity Omnimedia, Inc.
            </Col>
            <Col xs={12} md="auto" className="text-center">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="px-3">|</span>
              <Link onClick={handleClickTop} to="/terms-of-service">
                Terms of Use
              </Link>
              <span className="px-3">|</span>
              <Link onClick={handleClickTop} target="_blank" to="/business-associate-agreement">
                BAA
              </Link>
            </Col>
            <Col xs={12} md={4} className="cradit text-center text-md-end d-none">
              Designed and developed by{" "}
              <a href="https://www.brethren.co" target="_blank" className="credit-link" rel="noreferrer">
                <img src={cradit} alt="Brethren" />
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <SubscriptionModal isOpen={showModel} onClosed={() => setShowModel(false)} userDetails={userDetails} resetForm={resetForm} handleChange={handleChange} />
    </footer>
  );
};
export default FooterBottom;
